export enum ApiRegistrationKnownErrorsEnum {
  CREATION_TOKEN_NOT_FOUND = 'CREATION_TOKEN_NOT_FOUND',
  CREATION_TOKEN_EXPIRED = 'CREATION_TOKEN_EXPIRED',
  CREATION_TOKEN_AND_USER_MISMATCH = 'CREATION_TOKEN_AND_USER_MISMATCH',
}
